<template>
    <div class="filters-content-clients">

        <div class="client-list-button">
            <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-danger"
                class="btn-icon btn-client" @click="onClear">
                {{ $t('MANAGE_NEWS_FILTER.Clear') }}
            </b-button>
            <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-danger" class="btn-icon btn-client"
                @click="onSubmit">
                {{ $t('MANAGE_NEWS_FILTER.Search') }}
            </b-button>
        </div>

        <div class="row-filters">
            <div class="col-md-12 client-filter">
                <b-form-group>
                    <b-form-input v-model="emailModel" label="name" class="client-list-filter"
                        :placeholder="$t('MANAGE_CLIENTS_FILTER.Email')" @keyup.enter="onSubmit">
                        <span slot="no-options"></span>
                    </b-form-input>
                </b-form-group>
            </div>

            <div class="col-md-12 client-filter">
                <b-form-group>
                    <b-form-input v-model="nameModel" label="name" class="client-list-filter"
                        :placeholder="$t('MANAGE_CLIENTS_FILTER.Name')" @keyup.enter="onSubmit">
                        <span slot="no-options"></span>
                    </b-form-input>
                </b-form-group>
            </div>

            <div class="col-md-12 client-filter">
                <b-form-group>
                    <v-select v-model="profileModel" label="name" class="client-list-filter"
                        :options="profile" :placeholder="$t('MANAGE_CLIENTS_FILTER.Profile')" :reduce="option => option.id"  @input="onSubmit">
                        <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                    </v-select>
                </b-form-group>
            </div>

            <div class="col-md-12 client-filter">
                <b-form-group>
                    <b-form-input v-model="logicalUserModel" label="name"
                        class="client-list-filter"
                        :placeholder="$t('MANAGE_CLIENTS_FILTER.LogicalUser')" @keyup.enter="onSubmit">
                        <span slot="no-options"></span>
                    </b-form-input>
                </b-form-group>
            </div>

            <div class="col-md-12 client-filter">
                <b-form-group>
                    <v-select v-model="countryModel" label="name" class="client-list-filter"
                        :options="country" :placeholder="$t('MANAGE_CLIENTS_FILTER.Country')" :reduce="option => option.id" @input="onSubmit">
                        <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                    </v-select>
                </b-form-group>
            </div>

            <div class="col-md-12 client-filter">
                <b-form-group>
                    <v-select v-model="logicalNumberModel" label="name"
                        class="client-list-filter" :options="logical_number"
                        :placeholder="$t('MANAGE_CLIENTS_FILTER.LogicalNumber')" :reduce="option => option.id" @input="onSubmit">
                        <span slot="no-options"></span>
                    </v-select>
                </b-form-group>
            </div>

            <div class="col-md-12 client-filter">
                <b-form-group>
                    <v-select v-model="registerSystemFromModel" label="name"
                        class="client-list-filter" :options="register_system_from"
                        :placeholder="$t('MANAGE_CLIENTS_FILTER.RegistrationOrigin')" :reduce="option => option.id" @input="onSubmit">
                        <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                    </v-select>
                </b-form-group>
            </div>

            <div class="col-md-12 client-filter">
                <b-form-group>
                    <v-select v-model="originModel" label="name"
                        class="client-list-filter" :options="origin"
                        :placeholder="$t('MANAGE_CLIENTS_FILTER.SystemOrigin')" :reduce="option => option.id" @input="onSubmit">
                        <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                    </v-select>
                </b-form-group>
            </div>

            <div class="col-md-12 client-filter">
                <b-form-group>
                    <v-select v-model="signatureModel" label="name"
                        class="client-list-filter" :options="signature"
                        :placeholder="$t('MANAGE_CLIENTS_FILTER.Signatures')" :reduce="option => option.id" @input="onSubmit">
                        <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                    </v-select>
                </b-form-group>
            </div>

            <div class="col-md-12 client-filter">
                <b-form-group>
                    <div>
                        <flat-pickr v-model="dtCreateModel" class="client-list-filter"
                            @on-change="onSubmit"
                            :placeholder="$t('MANAGE_CLIENTS_FILTER.DtCreate')" :config="{
                                enableTime: false,
                                dateFormat: 'Y-m-d',
                                altInput: true,
                                altFormat: 'd/m/Y',
                                allowInput: true,
                                mode: 'range',
                            }" />
                    </div>
                </b-form-group>
            </div>

            <div class="col-md-12 client-filter">
                <b-form-group>
                    <div>
                        <flat-pickr v-model="dtUpdateModel" class="client-list-filter"
                            @on-change="onSubmit"
                            :placeholder="$t('MANAGE_CLIENTS_FILTER.DtUpdate')" :config="{
                                enableTime: false,
                                dateFormat: 'Y-m-d',
                                altInput: true,
                                altFormat: 'd/m/Y',
                                allowInput: true,
                                mode: 'range',
                            }" />
                    </div>
                </b-form-group>
            </div>

            <div class="col-md-12 client-filter">
                <b-form-group>
                    <div>
                        <flat-pickr v-model="sigaLoginInicioModel" class="client-list-filter"
                            @on-change="onSubmit"
                            :placeholder="$t('MANAGE_CLIENTS_FILTER.SigaLoginInício')" :config="{
                                enableTime: false,
                                dateFormat: 'Y-m-d',
                                altInput: true,
                                altFormat: 'd/m/Y',
                                allowInput: true,
                                mode: 'range',
                            }" />
                    </div>
                </b-form-group>
            </div>

            <div class="col-md-12 client-filter">
                <b-form-group>
                    <div>
                        <flat-pickr v-model="sigaLoginTerminoModel" class="client-list-filter"
                            @on-change="onSubmit"
                            :placeholder="$t('MANAGE_CLIENTS_FILTER.SigaLoginTérmino')" :config="{
                                enableTime: false,
                                dateFormat: 'Y-m-d',
                                altInput: true,
                                altFormat: 'd/m/Y',
                                allowInput: true,
                                mode: 'range',
                            }" />
                    </div>
                </b-form-group>
            </div>

            <div class="col-md-12 client-filter">
                <b-form-group>
                    <v-select v-model="activeModel" label="name" class="client-list-filter"
                        :placeholder="$t('MANAGE_CLIENTS_FILTER.Enabled')" :options="active"
                        :reduce="option => option.value" @input="onSubmit">
                        <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                    </v-select>
                </b-form-group>
            </div>
        </div>
    </div>
</template>

<script>
import { BButton, BFormGroup, BFormInput } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import dropdownService from '@/providers/dropdownService';


export default {
    directives: {
        Ripple,
    },
    components: {
        BButton,
        BFormGroup,
        flatPickr,
        BFormInput,
        vSelect,
    },
    props: {
    },
    data() {
        return {
            emailModel: null,
            nameModel: null,
            profileModel: null,
            logicalNumberModel: null,
            countryModel: null,
            logicalUserModel: null,
            registerSystemFromModel: null,
            originModel: null,
            signatureModel: null,
            dtCreateModel: null,
            dtUpdateModel: null,
            sigaLoginInicioModel: null,
            sigaLoginTerminoModel: null,
            activeModel: false,
            profile: [],
            logical_number: [],
            country: [],
            register_system_from: [],
            origin: [],
            signature: [],
            active: [
                {
                    name: "Todos",
                    value: ""
                },
                {
                    name: "Habilitado",
                    value: "true"
                },
                {
                    name: "Desabilitado",
                    value: "false"
                },
            ]
        }
    },
    mounted() {
        this.loadDataFilter();
    },
    methods: {
        onClear() {
            this.emailModel = '',
            this.nameModel = '',
            this.profileModel = '',
            this.logicalNumberModel = '',
            this.countryModel = '',
            this.logicalUserModel = '',
            this.registerSystemFromModel = '',
            this.originModel = '',
            this.signatureModel = '',
            this.dtCreateModel = '',
            this.dtUpdateModel = '',
            this.sigaLoginInicioModel = '',
            this.sigaLoginTerminoModel = '',
            this.activeModel = ''
        },
        loadDataFilter() {
            const params = new URLSearchParams();
            params.append('sync_client_siga', true);
            Promise.all([
                dropdownService.getAllClientProfile(new URLSearchParams()),
                dropdownService.getAllCountries(new URLSearchParams()),
                dropdownService.getAllLogicalNumber(new URLSearchParams()),
                dropdownService.getClientRegisterSystemFrom(new URLSearchParams()),
                dropdownService.getClientSignatures(new URLSearchParams()),
                dropdownService.getAllOrigin(params),
            ])
                .then((res) => {
                    this.profile = res[0];
                    this.country = res[1];
                    this.logical_number = res[2];
                    this.register_system_from = res[3];
                    this.signature = res[4];
                    this.origin = res[5];
                })
                .catch((err) => console.log(err));
        },
        onSubmit() {
            const filters = {}
            if (this.emailModel) {
                filters.email = this.emailModel
            }
            if (this.nameModel) {
                filters.name = this.nameModel
            }
            if (this.profileModel) {
                filters.profile = this.profileModel
            }
            if (this.logicalUserModel) {
                filters.logicalUser = this.logicalUserModel
            }
            if (this.countryModel) {
                filters.country = this.countryModel
            }
            if (this.logicalNumberModel) {
                filters.logicalNumber = this.logicalNumberModel
            }
            if (this.registerSystemFromModel) {
                filters.registerSystemFrom = this.registerSystemFromModel
            }
            if (this.originModel) {
                filters.origin = this.originModel
            }
            if (this.signatureModel) {
                filters.signature = this.signatureModel
            }
            if (this.dtCreateModel) {
                filters.dtCreate = this.dtCreateModel
            }
            if (this.dtUpdateModel) {
                filters.dtUpdate = this.dtUpdateModel
            }
            if (this.sigaLoginInicioModel) {
                filters.sigaLoginInicio = this.sigaLoginInicioModel
            }
            if (this.sigaLoginTerminoModel) {
                filters.sigaLoginTermino = this.sigaLoginTerminoModel
            }
            if (this.activeModel) {
                filters.active = this.activeModel
            }
            this.$emit('updateData', filters)
        }
    },

};
</script>

<style>

.row-filters {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    gap: 1rem;
}

.client-list-filter {
    border-radius: 0;
}

.filters-content-clients {
    display: flex;
    margin-top: 25px;
    flex-wrap: wrap;
}


.client-list-button {
    width: 100%;
    display: flex;
    margin-bottom: 10px;
    justify-content: space-between;
}

.client-filter {
    padding: 0;
}


</style>